import { useState } from "react";
import { useAuthContext } from "../providers/AuthProvider";
import LoginLayout from "../layouts/LoginLayout";
import Button from "../components/Button";
import InputMask from "../components/InputMask";
import { useTranslation } from "react-i18next";
import { useConfigContext } from "../providers/ConfigProvider";

const AuthDashboard = () => {
    const { t } = useTranslation();
    const { login } = useAuthContext();
    const { companyWebsite } = useConfigContext();

    const [nin, setNin] = useState('');

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        login(nin);
    }

    return (
        <LoginLayout
            title={t('login_title')}
            helperText={t('login_description') + ' <a href="' + companyWebsite + '" target="_blank" rel="noopener noreferrer">' + t('login_description_link') + '</a>.'}
            display="col-md-7 col-lg-6"
        >
            <div className="bankid-login-container border rounded-1 text-center bg-body-tertiary mb-4">
                <div className="bankid-login-content mx-auto my-4 py-2 px-3">
                    <div className="d-flex align-items-center mb-4">
                        <img src="/svg/bank-id-icon.svg" alt="BankID Logo" className="bankid-logo me-3" />
                        <div className="text-start">
                            <h5 className="mb-0">{t('login_bankid')}</h5>
                            <span className="text-muted">{t('login_bankid_description')}</span>
                        </div>
                    </div>
                    <form className="text-start" onSubmit={handleSubmit}>
                        <div className="mb-4" style={{ maxWidth: '302px' }}>
                            <InputMask
                                type="inputmask"
                                value={nin}
                                mask="000000 00000"
                                replace=" "
                                replaceWith=""
                                label={t('input_nin_label')}
                                name="nin"
                                placeholder=""
                                onChange={(value) => setNin(value)}
                                error={nin.length !== 11 ? t('login_bankid_error') : ''}
                                required
                                rules={{}}
                            />
                        </div>
                        <Button
                            title={t('next')}
                            type="primary"
                            onClick={() => login(nin)}
                            disabled={nin.length != 11}
                        />
                    </form>
                </div>
            </div>
        </LoginLayout>
    )
}

export default AuthDashboard;